import './App.css';
import MainPage from './components/MainPage.tsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import * as constants from './misc/Constants.tsx';
import { Navigate } from 'react-router-dom';
import NoSsr from '@mui/material/NoSsr';
import * as user from './misc/UserFunctions.ts';
import { DependenciesProvider } from './misc/DependenciesProvider.tsx';
import * as frac_api from './api/FracApi.ts';

import { LogonPage } from './components/LogonPage.tsx';
import { SnackbarMessageProvider } from './components/SnackMessge.tsx';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const dependencies = {
  fracAPI: new frac_api.FracApi(),
};

function App() {
  return (
    <NoSsr>
      <div>
        <DependenciesProvider dependencies={dependencies}>
          <SnackbarMessageProvider>
            <Router>
              <Routes>
                {user.isLoggedIn() &&
                  <>
                    {constants.pages.map((page) => (
                      <Route path={'/' + constants.pageToUrlName[page]} element={<MainPage />} key={page} />
                    ))}

                    <Route path="*" element={<Navigate to={`/${constants.pageToUrlName[constants.dashboardPage]}`} />} />



                  </>

                }

                <Route path="/login" element={<LogonPage />} />

                {!user.isLoggedIn() &&
                  <Route path="*" element={<LogonPage />} />
                }

              </Routes>
            </Router>

          </SnackbarMessageProvider>
        </DependenciesProvider>

      </div>
    </NoSsr>
  );
}


export default App;
